import imageCompression from "browser-image-compression";
import { supabase } from "./supabase";

const IMAGE_TYPES = ["image/jpeg", "image/png", "image/webp"];

export const KINDS = {
  image: { types: IMAGE_TYPES, maxMB: 5, hint: "JPG, PNG or WEBP, up to 5 MB" },
  video: { types: ["video/mp4", "video/webm", "video/quicktime"], maxMB: 25, hint: "MP4, WEBM or MOV, up to 25 MB" },
  document: { types: [...IMAGE_TYPES, "application/pdf"], maxMB: 5, hint: "JPG, PNG, WEBP or PDF, up to 5 MB" },
};

export function checkFile(file, kind) {
  const rule = KINDS[kind];
  if (!rule.types.includes(file.type)) return `Unsupported file type. Allowed: ${rule.hint}`;
  const limit = file.type === "application/pdf" ? 5 : rule.maxMB;
  if (file.size > limit * 1024 * 1024) return `File is too large. Maximum size is ${limit} MB`;
  return null;
}

export async function uploadFile({ file, kind, bucket, folder, userId }) {
  let blob = file;
  let type = file.type;
  if (IMAGE_TYPES.includes(type)) {
    blob = await imageCompression(file, { maxSizeMB: 1, maxWidthOrHeight: 1200, useWebWorker: true, fileType: "image/webp", initialQuality: 0.8 });
    type = "image/webp";
  }
  const ext = type === "image/webp" ? "webp" : (file.name.split(".").pop() || "bin").toLowerCase();
  const path = `${userId}/${folder}/${crypto.randomUUID()}.${ext}`;
  const { error } = await supabase.storage.from(bucket).upload(path, blob, { contentType: type, upsert: false });
  if (error) throw error;
  return { path, name: file.name, type, bucket, kind };
}

export async function removeFile(item) {
  if (item?.path) await supabase.storage.from(item.bucket).remove([item.path]);
}
